////////LIBRARY/////////
import React, { useEffect, useState, Fragment, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useForm } from 'react-hook-form'
import { bindActionCreators } from 'redux'
import { cloneDeep, map, isUndefined, isEmpty, find, filter, reject, includes } from 'lodash'
import styled from 'styled-components'
///////COMPONENTS///////
import { uriList } from '../../routings/settings/RouteList'
import {
	PageWrapper,
	PageTitle,
	PageWrapperActions,
	PageWrapperActionReset,
	PageWrapperActionPrevPage,
	PageWrapperActionValidate,
	PageWrapperGrids,
	TextModal,
	ButtonWrapper,
	InputWrapper,
	InputLogin,
	ErrorInputMsg,
} from '../../theme/GlobalCss'
import { tagsManagerActionCreators } from '../../store/actions'
import TagsListManager from './TagsListManager'
import TagsListUnaffectedManager from './TagsListUnaffectedManager/'
import TagsListAffectedManager from './TagsListAffectedManager/'
import Tooltip from '../../components/Tooltip/Tooltip'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import userPrivileges from '../../constants/PrivilegesList'
import TooltipHelp from '../../components/TooltipHelp'
/////////ASSETS/////////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const PageGridOverflow = styled.div`
	overflow-y: scroll;
	max-height: 50vh;
`
const TagsManagerWrapper = styled.div`
	position: relative;
`
const TagsManagerModalCreateWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	align-content: center;
	& > * {
		margin: 10px 5px;
	}
	width: 410px;
	text-align: center;
`
const RolesManagerRecapWrapper = styled.div`
	display: flex;
	& > div:nth-child(2) {
		border-left: 1px solid ${(props) => props.theme.colors.listNav.border};
		margin-left: 11px;
	}
`
const RolesManagerRecap = styled.div`
	display: flex;
	justify-content: space-between;
	& > div {
		width: 50%;
	}
`
const RecapItem = styled.div`
	padding: 10px 11px;
	display: flex;
	align-items: center;
`
const RecapItemInput = styled.input`
	margin: 0px 19px 0px 0px;
`
const RecapItemLabel = styled.label`
	color: ${(props) => (props.foundInList ? props.theme.text.colors.primary : props.theme.colors.error)};
	text-decoration-line: ${(props) => (props.foundInList ? 'none' : 'line-through')};
`
//////STYLED//////

const TagsManager = (props) => {
	const [stateDefaultValuesModal, setStateDefaultValuesModal] = useState({
		tagName: '',
	})

	const { translations, tagsManager, userDetail, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			tagsManager: state.tagsManager,
			userDetail: state.userDetail,
			user: state.user,
		}),
		shallowEqual
	)

	const actionsTagsManager = bindActionCreators(tagsManagerActionCreators, useDispatch())

	const [modalCreateMode, setModalCreateMode] = useState(true)
	const [showModal, setShowModal] = useState(false)
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const [tagModal, setTagModal] = useState()

	const [listIdSelected, setListIdSelected] = useState() // List of checked tags
	const [listUnaffected, setListUnaffected] = useState([]) // List of checked unaffected users/kiosks (ids)
	const [listAffected, setListAffected] = useState([]) // List of checked affected users/kiosks (ids)
	const [listObjUnaffected, setListObjUnaffected] = useState([]) // List of moved unaffected items (objects) => is constantly refreshed
	const [listObjAffected, setListObjAffected] = useState([]) // List of moved affected items (objects) => is constantly refreshed

	const [shiftedDataAff, setShiftedDataAff] = useState([]) // All affected elements used for validation
	const [shiftedDataUnaff, setShiftedDataUnaff] = useState([]) // All unaffected elements used for validation

	const [lockShiftItems, setLockShiftItems] = useState(false) // Lock or not items to be shifted

	const [mode, setMode] = useState()

	const listRef = useRef()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleModal = (dataRow) => {
		if (!isUndefined(dataRow)) {
			setModalCreateMode(false)
			setTagModal(dataRow)
		} else {
			setModalCreateMode(true)
			setTagModal()
		}
		setShowModal((prevState) => !prevState)
	}

	const handleDeleteModal = (dataRow) => {
		!isUndefined(dataRow) ? setTagModal(dataRow) : setTagModal()
		setShowDeleteModal((prevState) => !prevState)
	}

	const handleValidationTags = () => {
		// We take all items that went unaffected / affected

		// We will compare baseData of each list, versus current input data,
		// to know what items in total are shifted !
		let datas = {}

		if (!isEmpty(shiftedDataUnaff) || !isEmpty(shiftedDataAff))
			if (mode === 'user') {
				datas = { usersTagToUpdate: [] }
				// If user is in shiftedDataAff, it means that now he is affected at tag
				map(shiftedDataAff, (elem, _id) => {
					datas.usersTagToUpdate.push({
						idUser: elem.id,
						idTags: listIdSelected,
						toLinked: true,
					})
				})

				/// If user is in shiftedDataUnaff, it means that now he is not affected at tag
				map(shiftedDataUnaff, (elem, _id) => {
					datas.usersTagToUpdate.push({
						idUser: elem.id,
						idTags: listIdSelected,
						toLinked: false,
					})
				})
			} else {
				datas = { kiosksTagToUpdate: [] }
				// If kiosk is in shiftedDataAff, it means that now he is affected at tag
				map(shiftedDataAff, (elem, _id) => {
					datas.kiosksTagToUpdate.push({
						idKiosk: elem.id,
						idTags: listIdSelected,
						toLinked: true,
					})
				})

				/// If kiosk is in shiftedDataUnaff, it means that now he is not affected at tag
				map(shiftedDataUnaff, (elem, _id) => {
					datas.kiosksTagToUpdate.push({
						idKiosk: elem.id,
						idTags: listIdSelected,
						toLinked: false,
					})
				})
			}

		if (!isEmpty(datas)) {
			mode === 'user' ? actionsTagsManager.updateTagContent(datas, 'user') : actionsTagsManager.updateTagContent(datas, 'kiosk')
			// Reset every selection when updated
			setListUnaffected([])
			setListObjUnaffected([])
			setListAffected([])
			setListObjAffected([])
			setShiftedDataUnaff([])
			setShiftedDataAff([])
		}
	}

	const {
		register: registerModal,
		handleSubmit: handleSubmitModal,
		errors: errorsModal,
		setValue: setValueModal,
		getValues: getValuesModal,
	} = useForm({
		defaultValues: stateDefaultValuesModal,
	})

	const onSubmitHeader = (data) => {
		let datas = cloneDeep(data)
		if (modalCreateMode) {
			actionsTagsManager.createTag(datas)
			handleModal()
		} else {
			if (!isUndefined(tagModal)) {
				actionsTagsManager.updateTagHeader(tagModal?.id, datas)
				handleModal()
			}
		}
	}

	const handleShiftedDataToAdd = (inputDataUnAff) => {
		let finalData = []
		if (mode === 'user') {
			if (tagsManager.tagDetail.users !== false) {
				// We merge all elements
				const allData = [...tagsManager.tagDetail.users.usersWithoutTags, ...tagsManager.tagDetail.users.usersWithTags]
				finalData = cloneDeep(allData)
				// We remove all current elements in unaffected list
				finalData = reject(finalData, (o) => {
					return find(inputDataUnAff, o) ? true : false
				})

				// And also all elements that were in first place in affected list
				finalData = reject(finalData, (o) => {
					return find(tagsManager.tagDetail.users.usersWithTags, o) ? true : false
				})
			}
		} else {
			if (tagsManager.tagDetail.kiosks !== false) {
				// We merge all elements
				const allData = [...tagsManager.tagDetail.kiosks.kiosksWithoutTags, ...tagsManager.tagDetail.kiosks.kiosksWithTags]
				finalData = cloneDeep(allData)
				// We remove all current elements in unaffected list
				finalData = reject(finalData, (o) => {
					return find(inputDataUnAff, o) ? true : false
				})
				// And also all elements that were in first place in affected list
				finalData = reject(finalData, (o) => {
					return find(tagsManager.tagDetail.kiosks.kiosksWithTags, o) ? true : false
				})
			}
		}
		// So we set all elements that moved only
		setShiftedDataAff(finalData)
	}

	// To set data removed for validation
	const handleShiftedDataToRemove = (inputDataAff) => {
		let finalData = []
		if (mode === 'user') {
			if (tagsManager.tagDetail.users !== false) {
				// We merge all elements
				const allData = [...tagsManager.tagDetail.users.usersWithoutTags, ...tagsManager.tagDetail.users.usersWithTags]
				finalData = cloneDeep(allData)

				// We remove all current elements in affected list
				finalData = reject(finalData, (o) => {
					return find(inputDataAff, o) ? true : false
				})

				// And also all elements that were in first place in unaffected list
				finalData = reject(finalData, (o) => {
					return find(tagsManager.tagDetail.users.usersWithoutTags, o) ? true : false
				})
			}
		} else {
			if (tagsManager.tagDetail.kiosks !== false) {
				// We merge all elements
				const allData = [...tagsManager.tagDetail.kiosks.kiosksWithoutTags, ...tagsManager.tagDetail.kiosks.kiosksWithTags]
				finalData = cloneDeep(allData)

				// We remove all current elements in affected list
				finalData = reject(finalData, (o) => {
					return find(inputDataAff, o) ? true : false
				})

				// And also all elements that were in first place in unaffected list
				finalData = reject(finalData, (o) => {
					return find(tagsManager.tagDetail.kiosks.kiosksWithoutTags, o) ? true : false
				})
			}
		}
		// So we set all elements that moved only
		setShiftedDataUnaff(finalData)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(listIdSelected)) {
			let preparedList = []
			// We take any tag object in listIdSelected
			preparedList = reject(tagsManager.items, (o) => {
				return includes(listIdSelected, o.id) ? false : true
			})

			// We also need to check if any public tag is selected
			// When it is the case, we cannot select and shift items
			const f_publictags = filter(preparedList, { isPrivate: false })
			f_publictags.length > 0 ? setLockShiftItems(true) : setLockShiftItems(false)

			if (isUndefined(listRef.current) || listIdSelected !== listRef.current) {
				mode === 'user' ? actionsTagsManager.getTagDetail(preparedList, 'user') : actionsTagsManager.getTagDetail(preparedList, 'kiosk')
				setListObjUnaffected([])
				setListObjAffected([])
				setShiftedDataUnaff([])
				setShiftedDataAff([])
			}
		} else {
			// We need a reset of detail, not the entire tag list !
			if (!isEmpty(listRef.current)) actionsTagsManager.resetTagDetail()
		}
		listRef.current = listIdSelected
	}, [listIdSelected])

	useEffect(() => {
		if (!isUndefined(tagModal) && showModal && !modalCreateMode) {
			setValueModal('tagName', tagModal?.name)
			setStateDefaultValuesModal(getValuesModal)
		}
	}, [showModal])

	useEffect(() => {
		if (!isUndefined(props.userMode)) {
			setMode('user')
		} else if (includes(window.location.pathname, uriList.tagsUsersManager)) {
			setMode('user')
		} else {
			setMode('kiosk')
		}
	}, [])

	// To set data added for validation

	// Prechecking tags if in user mode
	useEffect(() => {
		if (mode === 'user' && props.userMode) {
			let arr = map(userDetail.items.privateTags.tags, 'id')
			map(userDetail.items.publicTags.tags, (elem) => {
				arr.push(elem.id)
			})
			setListIdSelected(arr)
		}
	}, [userDetail.items, mode])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={translations['modal__tagManagement__delete_placeholder']}
				closeModalHandler={handleDeleteModal}
				showModal={showDeleteModal}
				insideModal={!isUndefined(props.userMode)}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__tagManagement__delete_warning']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleDeleteModal}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => {
							actionsTagsManager.deleteTag(tagModal?.id)
							handleDeleteModal()
						}}
						text={translations['common__text__delete']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={
					modalCreateMode
						? translations['modal__tagManagement__create_placeholder']
						: translations['modal__tagManagement__edit_placeholder']
				}
				closeModalHandler={handleModal}
				showModal={showModal}
				insideModal={!isUndefined(props.userMode)}
				icon={true}
			>
				<form onSubmit={handleSubmitModal(onSubmitHeader)}>
					<TextModal>
						<TagsManagerModalCreateWrapper>
							<p>
								{modalCreateMode
									? translations['modal__tagManagement__newTag_name']
									: translations['modal__tagManagement__editTag_name']}
							</p>
							<InputWrapper>
								<InputLogin
									name="tagName"
									type="text"
									placeholder={translations['modal__tagManagement__newTag_name_placeholder']}
									ref={registerModal({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: '',
										},
									})}
								/>
								{errorsModal.tagName && <ErrorInputMsg>{errorsModal.tagName.message}</ErrorInputMsg>}
							</InputWrapper>
						</TagsManagerModalCreateWrapper>
					</TextModal>
					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>

						<Button
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
							actionHandler={handleSubmitModal(onSubmitHeader)}
						/>
					</ButtonWrapper>
				</form>
			</Modals>
			<TagsManagerWrapper>
				<PageWrapper>
					<PageTitle>
						{mode === 'user' ? (
							<TooltipHelp content={'tooltipHelp__admin__modal__body__tagManagement__userTag'} insideModal>
								{translations['page__tagManagement__user_title']}
							</TooltipHelp>
						) : (
							<TooltipHelp content={'tooltipHelp__admin__modal__body__tagManagement_kiosk__tagList'}>
								{translations['page__tagManagement__kiosk_title']}
							</TooltipHelp>
						)}
					</PageTitle>
					<PageWrapperActions absolute>
						<Tooltip tooltipId={'tagsSubmit'} translationsKey={'tooltip__admin__global__save'}>
							<PageWrapperActionValidate
								unlocked={
									(!isEmpty(shiftedDataUnaff) || !isEmpty(shiftedDataAff)) &&
									!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[12]))
								}
								onClick={() => {
									if (
										(!isEmpty(shiftedDataUnaff) || !isEmpty(shiftedDataAff)) &&
										!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[12]))
									)
										handleValidationTags()
								}}
							/>
						</Tooltip>
						{props.userMode && <PageWrapperActionPrevPage onClick={() => props.closeModalHandler()} />}
						<Tooltip tooltipId={'tagsReset'} translationsKey={'tooltip__admin__global__reset'}>
							<PageWrapperActionReset
								onClick={() => {
									setListIdSelected()
									actionsTagsManager.resetTag()
								}}
							/>
						</Tooltip>
					</PageWrapperActions>
					<PageWrapperGrids grids={3}>
						<TagsListManager
							showCreationModal={handleModal}
							showDeleteModal={handleDeleteModal}
							currentListSelected={listIdSelected}
							listSelected={setListIdSelected}
							ref={listRef}
						/>
						{!isUndefined(tagsManager.tagDetail.users.usersWithoutTags) && (
							<TagsListUnaffectedManager
								mode="user"
								baseData={tagsManager.tagDetail.users.usersWithoutTags}
								listUnaffected={listUnaffected}
								setListUnaffected={setListUnaffected}
								listObjUnaffected={listObjUnaffected}
								setListObjUnaffected={setListObjUnaffected}
								listAffected={listAffected}
								listObjAffected={listObjAffected}
								baseDataAff={tagsManager.tagDetail.users.usersWithTags}
								modalMode={props.userMode}
								handleShiftedDataToAdd={handleShiftedDataToAdd}
							/>
						)}
						{!isUndefined(tagsManager.tagDetail.kiosks.kiosksWithoutTags) && (
							<TagsListUnaffectedManager
								mode="kiosk"
								baseData={tagsManager.tagDetail.kiosks.kiosksWithoutTags}
								listUnaffected={listUnaffected}
								setListUnaffected={setListUnaffected}
								listObjUnaffected={listObjUnaffected}
								setListObjUnaffected={setListObjUnaffected}
								listAffected={listAffected}
								listObjAffected={listObjAffected}
								baseDataAff={tagsManager.tagDetail.kiosks.kiosksWithTags}
								handleShiftedDataToAdd={handleShiftedDataToAdd}
								readOnly={lockShiftItems}
							/>
						)}
						{!isUndefined(tagsManager.tagDetail.users.usersWithTags) && (
							<TagsListAffectedManager
								mode="user"
								baseData={tagsManager.tagDetail.users.usersWithTags}
								listAffected={listAffected}
								setListAffected={setListAffected}
								listObjAffected={listObjAffected}
								setListObjAffected={setListObjAffected}
								listUnaffected={listUnaffected}
								listObjUnaffected={listObjUnaffected}
								baseDataUnaff={tagsManager.tagDetail.users.usersWithoutTags}
								modalMode={props.userMode}
								handleShiftedDataToRemove={handleShiftedDataToRemove}
								dataAdded={shiftedDataAff}
							/>
						)}
						{!isUndefined(tagsManager.tagDetail.kiosks.kiosksWithTags) && (
							<TagsListAffectedManager
								mode="kiosk"
								baseData={tagsManager.tagDetail.kiosks.kiosksWithTags}
								listAffected={listAffected}
								setListAffected={setListAffected}
								listObjAffected={listObjAffected}
								setListObjAffected={setListObjAffected}
								listUnaffected={listUnaffected}
								listObjUnaffected={listObjUnaffected}
								baseDataUnaff={tagsManager.tagDetail.kiosks.kiosksWithoutTags}
								handleShiftedDataToRemove={handleShiftedDataToRemove}
								dataAdded={shiftedDataAff}
								readOnly={lockShiftItems}
							/>
						)}
					</PageWrapperGrids>
				</PageWrapper>
			</TagsManagerWrapper>
		</Fragment>
	)
}

TagsManager.propTypes = {}

TagsManager.defaultPropTypes = {}

export default TagsManager
